import React, { FC, useCallback } from 'react';

import { GestureResponderEvent } from 'react-native';

import { ListItemButton, ListItemContent } from './styled';
import { IProductListItemProps } from './types';

const Container: FC<React.PropsWithChildren<Partial<IProductListItemProps>>> = ({
  children,
  isClickable,
  onProductClick,
  onNavigate,
  isHeader,
  accessibilityRole,
  accessibilityLabel,
  accessibilitySelected,
  accessibilityChecked,
}) => {
  const wrappedOnProductCta = useCallback(
    (e: GestureResponderEvent) => {
      // Generally not needed for React Native, but does not break anything.
      // On web, this stops the event capture phase here so the parent handles the click event.
      e.preventDefault();
      if (onNavigate) {
        onNavigate();
      } else if (onProductClick) {
        onProductClick();
      }
    },
    [onProductClick, onNavigate]
  );

  const listItemRole = onNavigate ? 'link' : accessibilityRole ? accessibilityRole : undefined;

  if (isClickable) {
    return (
      <ListItemButton
        testID="product-list-item-button"
        onPress={wrappedOnProductCta}
        isHeader={isHeader}
        accessible
        focusable
        {...(listItemRole && { accessibilityRole: listItemRole })}
        {...(accessibilityLabel && { accessibilityLabel })}
        {...(accessibilitySelected && { accessibilitySelected })}
        {...(accessibilityChecked && { accessibilityChecked })}
      >
        {children}
      </ListItemButton>
    );
  }
  return (
    <ListItemContent testID="product-list-item-content" isHeader={isHeader}>
      {children}
    </ListItemContent>
  );
};

export default Container;
